import { Navigate } from "react-router-dom";
import EmailTemplate from '../components/email';
import DashboardLayout from "../components/layout/DashboardLayout";
import UnauthorizedLayout from "../components/layout/UnauthorizedLayout";
import BudgetRequestControlScreen from "../pages/BudgetRequestControlScreen";
import BudgetScreen from "../pages/BudgetScreen";
import Login from "../pages/Login";
import MainMenuScreen from "../pages/MainMenuScreen";
import MotorScreen from "../pages/MotorScreen";
import NotFound from "../pages/NotFound";
import Register from "../pages/Register";
import { isLogged } from "../services/auth";

const PrivateRoute = ({ children }) => {
  if (isLogged()) return children;
  return <Navigate to="/login" />;
};

// const rolesMapping = {
//   'admin': [258, 283, 249],
//   'callCenter': [259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 284],
//   'canalDoAgente': [234],
// }

// const RoleRoute = ({ children, allowedRoles }) => {
//   if (!isLogged()) return <Navigate to="/login" />;

//   const userId = getUserId();

//   const hasAccess = allowedRoles.some(role => {
//     if (rolesMapping['admin'].includes(userId)) return true;

//     return rolesMapping[role]?.includes(userId);
//   });

//   if (hasAccess) return children;

//   return <Navigate to="/404" />;
// };

// const userRoles = isLogged()
//   ? Object.keys(rolesMapping).filter(role => rolesMapping[role].includes(getUserId()))
//   : [];

//PASSAR userRole NO DashboardLayout e DESCOMENTAR PATHS USANDO RoleRoute

const routes = [
  {
    path: "orcamentos",
    element: <DashboardLayout />,
    children: [
      // {
      //   path: "/orcamentos/",
      //   element: (
      //     <PrivateRoute>
      //       <BudgetScreen />
      //     </PrivateRoute>
      //   ),
      // },
      // {
      //   path: "/orcamentos/solicitacoes",
      //   element: (
      //     <RoleRoute allowedRoles={["callCenter"]}>
      //       <BudgetRequestControlScreen requestType="callCenter" />
      //     </RoleRoute>
      //   ),
      // },
      // {
      //   path: "/orcamentos/solicitacoes/canal-do-agente",
      //   element: (
      //     <RoleRoute allowedRoles={["canalDoAgente"]}>
      //       <BudgetRequestControlScreen requestType="canalAgente" />
      //     </RoleRoute>
      //   ),
      // },
      {
        path: "/orcamentos/call-center",
        element: (
          <PrivateRoute>
            <BudgetRequestControlScreen requestType="callCenter" />
          </PrivateRoute>
        ),
      },
      {
        path: "/orcamentos/canal-do-agente",
        element: (
          <PrivateRoute>
            <BudgetRequestControlScreen requestType="canalAgente" />
          </PrivateRoute>
        ),
      },
      {
        path: "/orcamentos/email",
        element: (
          <EmailTemplate />
        ),
      },
      { path: "*", element: <Navigate to="/404" /> },
    ],
  },
  {
    path: "/",
    element: <UnauthorizedLayout />,
    children: [
      { path: "login", element: <Login /> },
      { path: "register", element: <Register /> },
      { path: "404", element: <NotFound /> },
      {
        path: "/",
        element: (
          <PrivateRoute>
            <Navigate to="/inicio" />
          </PrivateRoute>
        ),
      },
      // {
      //   path: "users",
      //   element: (
      //     <RoleRoute allowedRoles={["admin"]}>
      //       <UserScreen />
      //     </RoleRoute>
      //   ),
      // },
      { path: "*", element: <Navigate to="/404" /> },
    ],
  },
  {
    path: "inicio",
    element: <DashboardLayout />,
    children: [
      {
        path: "/inicio/",
        element: (
          <PrivateRoute>
            <MainMenuScreen />
          </PrivateRoute>
        ),
      },
      {
        path: "relatorios",
        element: (
          <PrivateRoute>
            <BudgetScreen />
          </PrivateRoute>
        )
      },
      { path: "*", element: <Navigate to="/404" /> },
    ],
  },
  {
    path: "motor",
    element: <DashboardLayout />,
    children: [
      {
        path: "/motor/",
        element: (
          <PrivateRoute>
            <MotorScreen />
          </PrivateRoute>
        )
      },
      { path: "*", element: <Navigate to="/404" /> },
    ],
  },
];

export default routes;
